import Cookies from 'js-cookie';
import ActionTypes from '../actions/types';
import { getParams } from '../utils/getParams';

const queryParams = new URLSearchParams(window.location.search);

/**
 * @type {import('../typings').IStateReducerState}
 */

const initialState = {
	width: window.innerWidth,
	isMobile: window.innerWidth < 850 ? true : false,
	ticker: localStorage.getItem('SYMBOL')
		? localStorage.getItem('SYMBOL')
		: getParams('ticker') || '',
	data: [],
	selections: {},
	quoteInfo: {
		avgTotalVolume: 2606,
		calculationPrice: '',
		change: 0,
		changePercent: 0,
		close: null,
		closeSource: 'official',
		closeTime: null,
		companyName:
			'Piton Investment Management - ClearShares Piton Intermediate Fixed Inc',
		currency: 'USD',
		delayedPrice: null,
		delayedPriceTime: null,
		extendedChange: 0,
		extendedChangePercent: 0,
		extendedPrice: 99.11,
		extendedPriceTime: 0,
		high: 0,
		highSource: 'Close',
		highTime: 0,
		iexAskPrice: null,
		iexAskSize: null,
		iexBidPrice: null,
		iexBidSize: null,
		iexClose: null,
		iexCloseTime: null,
		iexLastUpdated: null,
		iexMarketPercent: null,
		iexOpen: null,
		iexOpenTime: null,
		iexRealtimePrice: null,
		iexRealtimeSize: null,
		iexVolume: null,
		lastTradeTime: 1620674710996,
		latestPrice: 0,
		latestSource: '',
		latestTime: '',
		latestUpdate: 0,
		latestVolume: 0,
		low: 0,
		lowSource: '',
		lowTime: 0,
		marketCap: 0,
		oddLotDelayedPrice: 0,
		oddLotDelayedPriceTime: 0,
		open: null,
		openTime: null,
		openSource: '',
		peRatio: null,
		previousClose: 0,
		previousVolume: 0,
		primaryExchange: '',
		symbol: getParams('ticker') || '',
		volume: 0,
		week52High: 0,
		week52Low: 0,
		ytdChange: 0,
		isUSMarketOpen: false,
	},
	oiModelData: '',
	selectedDate: '',
	expirationOptions: [],
	expiration: '',
	calendarData: {},
	refreshingData: false,
	refreshingQuote: false,
	tickerChanged: false,
	shadingActive: true,
	callsAnswer: '',
	pullsAnswer: '',
	confidence: 8,
	targetPrice: 0,
	onPlay: false,
	localData: [],
	skew: null,
	imp_vol: null,
	changeConfidenceDelay: false,

	educationInstance: null,
	dontChangeExpiration: false,
	uoa: [],
	errorUoa: '',
	sidepanelExpirations: [],
	sidepanelExpirationsLoading: false,
	sidepanelExpirationsErrors: null,
	articles: [],
	generalArticles: [],
	modalDetail: [],
	modalDetail2: [],
	modalDetail3: [],
	iexClose: '',
	OIDataCall: [],
	updatedAt: '',
	OIDataPut: [],
	OIDates: [],
	OIStrikes: [],
	OICallMax: 0,
	OIPutMax: 0,
	test: '',
	errorMessages: [],
	uoaModalData: [],
	modalLoader: false,
	stockFirstTable: [],
	stockSecondTable: [],
	stockThirdTable: [],
	topVolumeData: [],
	secondTopTableData: [],
	loading: false,
	secondLoading: false,
	ThirdLoading: false,
	weekendErrors: null,
	weekendErrorsBox2: null,
	weekendErrorsBox3: null,
	homeFirstTable: [],
	homeSecondTable: [],
	homeThirdTable: [],
	holderList: [],
	loginLoader: false,
	isAuthenticated: false,
	redirectLink: '/optionschain',
	userData: [],
	accessLevel: '',
	wp_token: {
		jwt_token: queryParams.get('jwt_token'),
		levels: queryParams.get('levels'),
		expires_in: queryParams.get('expires_in'),
	},
	wp_user_id: queryParams.get('user'),
	logout: queryParams.get('logout'),
	tokenExists: Cookies.get('token'),
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case ActionTypes.SET_APP_STATE:
			return {
				...state,
				...payload,
			};
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/appStateReducer.js